import { render, staticRenderFns } from "./Incidents.vue?vue&type=template&id=188d4aa2&"
import script from "./Incidents.vue?vue&type=script&lang=js&"
export * from "./Incidents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports